export default (ctx, inject) => {
  let siteUrl
  if (ctx.req && ctx.req.url) {
    siteUrl = ctx.req.url
  } else if (process.server) {
    const protocol = ctx.req.connection.encrypted ? 'https://' : 'http://'
    siteUrl = `${protocol}${ctx.req.headers.host}`
  } else {
    siteUrl = window.location.origin
  }


  inject('siteUrl', siteUrl)
}
